import { createSafeContext } from '@mews/framework';
import { WithChildren } from '@optimus-web/common';
import {
    FilterContextNames,
    ExtendedFilterContextValues,
    useFilterState,
    usePaginationState,
    useSelectedDateState,
} from '../../common/context/FilterContext';
import { useDefaultFilterValues } from '../components/Filters/utils/useDefaultFilterValues';
import { CityLedgerFilterValues } from '../components/Filters/utils/schema';
import { useIsPastDate } from '../utils/useIsPastDate';

const { CityLedgerFilterContextProvider, useCityLedgerFilterContext } = createSafeContext<
    FilterContextNames.CITY_LEDGER,
    ExtendedFilterContextValues<CityLedgerFilterValues>
>(FilterContextNames.CITY_LEDGER);

export const CityLedgerFilterProvider: React.FC<WithChildren> = ({ children }) => {
    const defaultValues = useDefaultFilterValues();
    const filterState = useFilterState<CityLedgerFilterValues>(defaultValues);
    const paginationState = usePaginationState();
    const selectedDateState = useSelectedDateState();

    return (
        <CityLedgerFilterContextProvider value={{ ...filterState, ...paginationState, ...selectedDateState }}>
            {children}
        </CityLedgerFilterContextProvider>
    );
};

export const useCityLedgerPagination = () => {
    const { pagination, setPagination, resetPagination } = useCityLedgerFilterContext();
    return { pagination, setPagination, resetPagination };
};

export const useCityLedgerSelectedDate = () => {
    const { selectedDate, setSelectedDate } = useCityLedgerFilterContext();
    const isPastDate = useIsPastDate(selectedDate);
    return { selectedDate, setSelectedDate, isPastDate };
};

export { useCityLedgerFilterContext };
